import React from 'react'
import PropTypes from 'prop-types'
import PlugIcon from 'commons/js/components/PlugIcon'
import { Box, themeColor } from '@elparking/components'
import styled from 'styled-components'

import { getPlugName } from '../PlugName'

const PlusIcon = styled.div`
    border: 1px solid ${themeColor('main')};
    height: 18px;
    width: 18px;
    border-radius: 50%;
    content: ' ';
    display: inline-block;
    position: relative;
    line-height: 18px;
    margin-bottom: -2px;
    
    &:before {
        font-size: 9px;
        height: 18px;
        width: 18px;
        color: ${themeColor('main')};
        text-align: center;
        position: absolute;
        content: '+${({number}) => number}';
        left: -1px;
    }
`

const IconBlock = styled.div`
    padding-right: 16px;
    display: inline-block;
    & > i {
        font-size: 20px;
    }
    color: ${themeColor('main')};
`

const Plugs = ({ plugs, max }) => {
    if (!plugs || plugs.length === 0) {
        return null
    }
    const plugsVisibles = plugs.length > max
        ? max - 1
        : plugs.length
    return <Box>
        { plugs.slice(0, plugsVisibles).map((plug) => <IconBlock key={plug.id}><PlugIcon plugName={getPlugName(plug.slug)} plugSlug={plug.slug} size='large'/></IconBlock>) }
        { plugs.length > max && <PlusIcon number={plugs.length - max + 1 } />}
    </Box>
}

Plugs.propTypes = {
    plugs: PropTypes.array,
    max: PropTypes.number,
}

Plugs.defaultProps = {
    max: null,
}

export default Plugs
